<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <ActivesTypeForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActivesTypeForm from '@/components/settings/stock-registers/activesType/ActivesTypeForm'

export default {
  name: 'ActivesType',
  components: {
    PageTitle,
    PageRowWrapper,
    ActivesTypeForm
  }
}
</script>
